import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./Map.module.css";

export const Map = () => {
  const { t } = useTranslation();
  const [activeCampus, setActiveCampus] = useState("shayxontohur");

  const campuses = [
    {
      id: "shayxontohur",
      nameKey: "campus_shayxontohur",
      embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1546.5786043269593!2d69.21753182137812!3d41.30405367041031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8bbe518958a3%3A0xabea1d7e79ecbc68!2sRenessans%20universitet!5e0!3m2!1sen!2s!4v1729504241279!5m2!1sen!2s&hl=en"
    },
    {
      id: "beruniy",
      nameKey: "campus_beruniy",
      embedUrl: "https://www.google.com/maps?q=41.340319,69.206518&z=15&output=embed&hl=en"
    },
    {
      id: "yunusobod",
      nameKey: "campus_yunusobod",
      embedUrl: "https://www.google.com/maps?q=41.352211,69.329887&z=15&output=embed&hl=en"
    }
  ];

  const activeMap = campuses.find(c => c.id === activeCampus) || campuses[0];

  return (
    <div className={classes["wrapper"]}>
      <div className={classes["tabs"]}>
        {campuses.map((campus) => (
          <button
            key={campus.id}
            className={`${classes["tab"]} ${activeCampus === campus.id ? classes["active"] : ""}`}
            onClick={() => setActiveCampus(campus.id)}
          >
            {t(campus.nameKey)}
          </button>
        ))}
      </div>
      <iframe
        className={classes["map"]}
        src={activeMap.embedUrl}
        width="100%"
        height="500"
        style={{ border: "none" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};
